import React from "react";
import "../../css/designSystem/Hero.css";
import PrimaryButton from "./buttons/PrimaryButton";
import LineLinkButton from "./buttons/LineLinkButton";
import SecondaryButton from "./buttons/SecondaryButton";
import { scrollToContact } from "../utils/navigation";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  pageTitle = "",
  title = "",
  subtitle = "",
  backgroundImage = "",
  showContactButton = true,
  showOverlay = true,
  compact = false,
  children,
  textAlign = "left",
  showButton=false

}) {
  return (
    <section
      className={`hero background-container bg-white ${
        backgroundImage ? "hero-has-background" : ""
      } ${backgroundImage && showOverlay ? "hero-with-overlay" : ""} ${
        compact ? "hero-compact" : ""
      }`}
      style={
        backgroundImage
          ? { backgroundImage: `url(${backgroundImage})` }
          : undefined
      }
    >
      <div className="content-container column-center gap-l hero-content-container py-xxl px-xxl">
        {pageTitle && <LineLinkButton children={pageTitle} />}
        {title && (
          <h4 className={`text-primary-1 uppercase text-${textAlign}`}>
            {renderLines(title)}
          </h4>
        )}
        {subtitle && (
          <p className={`content text-primary-1 text-${textAlign}`}>
            {renderLines(subtitle)}
          </p>
        )}
        {children}
        {showButton && (
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        )}
      </div>
    </section>
  );
}

export default Hero;
